import React, { useState, useEffect } from "react";
export var Quantity = function Quantity(_ref) {
  var value = _ref.value,
      min = _ref.min,
      max = _ref.max,
      _ref$onChange = _ref.onChange,
      _onChange = _ref$onChange === void 0 ? function (e) {
    return "";
  } : _ref$onChange;

  //TODO: Make this better
  var upper;

  if (Boolean(parseInt(max))) {
    upper = max;
  } else {
    upper = 99;
  }

  var options = [];

  for (var i = min; i <= upper; i++) {
    options.push({
      value: i,
      label: "Qty: " + i
    });
  }

  return /*#__PURE__*/React.createElement("div", {
    className: "cb-quantity-wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "cb-form__select-wrapper d-block"
  }, /*#__PURE__*/React.createElement("select", {
    className: "\n            cb-form__select\n            form-control\n            " // ${this.state.active ? 'is-active' : ''}
    // ${typeof field.value !== 'undefined' && field.value !== '' ? 'is-filled' : ''}
    ,
    defaultValue: value,
    name: "Quantity",
    onChange: function onChange(e) {
      e.persist();
      return _onChange(e.target.value);
    }
  }, options.map(function (option, index) {
    return /*#__PURE__*/React.createElement("option", {
      value: option.value,
      key: index
    }, option.label);
  }))));
};